import { Stack, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomChip } from 'src/shared/components/organisms/customChip';

type GroupMessageEmailStatusesProps = {
  chipSize: 'small' | 'medium' | undefined;
  sent?: boolean;
  error?: boolean;
  errorLabel?: string;
};

export const GroupMessageEmailStatuses = (props: GroupMessageEmailStatusesProps) => {
  const { chipSize, sent = undefined, error = undefined, errorLabel = undefined } = props;
  const { t } = useTranslation(['groupMessage']);

  return (
    <Stack direction='row' spacing={1} sx={{ '& .MuiChip-filled ': { borderRadius: 1 } }}>
      {sent === true && (
        <Tooltip describeChild title={t('groupMessage:sms.status.sent')} arrow>
          <CustomChip label={t('groupMessage:sms.status.sent')} color='success' size={chipSize} />
        </Tooltip>
      )}
      {sent === false && (
        <Tooltip describeChild title={t('groupMessage:sms.status.notSent')} arrow>
          <CustomChip label={t('groupMessage:sms.status.notSent')} color='warning' size={chipSize} />
        </Tooltip>
      )}
      {error === true && (
        <Tooltip describeChild title={errorLabel !== undefined ? errorLabel : t('groupMessage:email.error')} arrow>
          <CustomChip label={errorLabel !== undefined ? errorLabel : t('groupMessage:email.error')} color='error' size={chipSize} />
        </Tooltip>
      )}
      {error === false && <Typography color={(thm) => thm.palette.grey[400]}>--</Typography>}
    </Stack>
  );
};
